import styled from "styled-components"

const CardContainer = styled.div`
  padding: 0.5rem;
  display: grid;
  gap: 2rem;
  justify-items: center;
  @media screen and (min-width: 768px) {
    width: 1300px;
    margin-bottom: 3rem;
    margin-left: auto;
    margin-right: auto;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`

export { CardContainer }
